import styled from '../../components-v4/theme/styled';
import chevronIcon from '../../assets/chevron-right.svg';
import locationMax from '../../assets/location-max.svg';

export const GradientWrapper = styled.div`
  min-height: 56px;
  height: 100%;
  flex-shrink: 0;
  flex: 1;
  box-sizing: border-box;
  padding: 0 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.colors.purple[600]} 0%,
    ${(props) => props.theme.colors.purple[200]} 100%
  );
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    right: 35px;
    top: 50%;
    width: 130px;
    height: 130px;
    background-color: ${(props) => props.theme.colors.purple[500]};
    mask-image: url(${locationMax});
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-image: url(${locationMax});
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    transform: translateY(-50%) rotate(0deg);
    opacity: 0.6;
    pointer-events: none;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const Chevron = styled.img.attrs({
  src: chevronIcon,
})`
  width: 24px;
  height: 24px;
`;
